module.exports = __webpack_public_path__ + "img/worldmapwithpoints - gohi.fbe15520.svg";